import React, {Component} from 'react';
import {Breadcrumb, BreadcrumbItem, Button, ButtonGroup, Col, Container, Row} from "reactstrap";
import {Link} from "react-router-dom";
import UserPanelMenu from "../../components/user/UserPanelMenu";
import {API_URL, IMAGE_URL} from "../../config/Config";
import BootstrapTable from 'react-bootstrap-table-next';
import axios from "axios/index";
import {connect} from "react-redux";


class UserMerchantList extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
            activeTab: '1',
            data:[]
        };
    }
    async componentDidMount(){
        await this.getDataFromApi();
    }
    async getDataFromApi() {
        let response = await axios.get(`${API_URL}user-business?api_token=${this.props.user.apiToken}`);
        if (response.status < 200 || response.status > 300) {
            const error = new Error(response.statusText);
            error.response = response;
            console.log(error);
            alert("خطایی در هنگام دریافت اطلاعات رخ داد.");
        }else{
            let data = response.data.data;
            this.setState({data});
        }
        console.log("done");
        this.setState({loading: true});
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }
    render() {
        function imageView(cell) {
            return  (<img src={IMAGE_URL+cell} alt='business cover' style={{width:50, height:30}}/>);
        }
        function actionBtns(cell, row, rowIndex) {
            return (
                <ButtonGroup>
                    <Link to={`/merchant/${cell}`} className='btn btn-sm btn-primary'><i className="fa fa-search"/></Link>
                    {/*<Button size="sm" color="warning" onClick={()=>console.log(row)}><i className="fa fa-edit"/></Button>*/}
                    <Link to={`/edit-job/${cell}`} className='btn btn-sm btn-warning'><i className="fa fa-edit"/></Link>
                    <Button size="sm" color="danger" onClick={()=>alert(cell)} ><i className="fa fa-trash"/></Button>

                </ButtonGroup>
            );
        }
        function activeIndicator(cell, row, rowIndex) {
            if (cell === '1') {
                return (<i className='fa fa-check' style={{fontSize: 20, color: 'green'}}/>);
            }else{
                return (<i className='fa fa-close' style={{fontSize: 20, color: 'red'}}/>);
            }
        }
      /*  const selectRow = {
            mode: 'checkbox',
            clickToSelect: true,
        };*/
        const columns = [{
            dataField: 'id',
            text: 'شناسه',
            align: 'center',
            headerAlign: 'center',
            hidden: true
        }, {
            dataField: 'title',
            text: 'عنوان',
        }, {
            dataField: 'cover',
            text: 'تصویر',
            formatter: imageView,
            hidden: true
        },  {
            dataField: 'is_active',
            text: 'وضعیت',
            formatter: activeIndicator,
        }, {
            dataField: 'disabled_at',
            text: 'زمان اتمام بسته',
            hidden: true
        },{
            dataField: 'city.name',
            text: 'شهر',
        }, {
            dataField: 'categories[0].name',
            text: 'دسته بندی اصلی',
            hidden: true
        },{
            dataField: 'categories[1].name',
            text: 'دسته بندی',
        }, {
            dataField: 'created_at',
            text: 'تاریخ بارگذاری',
            hidden: true
        }, {
            dataField: 'id',
            text: 'ابزارها',
            formatter: actionBtns,
            headerAlign: 'center',
        }];
        return (
            <div className="pt-3">
                <Container>
                    <Breadcrumb className='w-100 white rounded mt-3 rtl'>
                        <BreadcrumbItem><Link to="/">خانه</Link></BreadcrumbItem>
                        <BreadcrumbItem><Link to="/users">کاربر</Link></BreadcrumbItem>
                        <BreadcrumbItem active>کسب و کارهای من</BreadcrumbItem>
                    </Breadcrumb>
                    <Row className='mt-3 md-5 rtl'>
                        <Col md='3' sm='12' className="">
                            <UserPanelMenu activeElement="3"/>
                        </Col>
                        <Col md='9' sm='12'>
                            <div className="panel panel-default white">
                                <div className="portlet-title">
                                    مدیریت کسب و کارها
                                </div>
                                <div className="portlet-body p-3">
                                    <Row>
                                        <Col md='12'>
                                            <Link to="/new-job" className='btn btn-default btn-outline-default mb-4'><i className="fa fa-plus" style={{color:"#4fbfa8"}}></i> افزودن کسب و کار جدید </Link>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md='12'>
                                            <div className="table-responsive">
                                                <BootstrapTable
                                                    classes="data-table table-striped"
                                                    keyField='id'
                                                    data={this.state.data}
                                                    columns={ columns }
                                                    bordered={ false }
                                                    noDataIndication="موردی یافت نشد."
                                                    // selectRow={ selectRow }
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
    }
}

export default connect(mapStateToProps,null)(UserMerchantList);


// WEBPACK FOOTER //
// ./src/containers/merchants/UserMerchantList.js